import React from "react"
import { Spacer } from "@bw/bits"
import { motion } from "framer-motion"
import { Link } from "gatsby"
import styled, { css } from "styled-components"
import { breakpoints } from "../../../theme"

const activeStyle = {
  fontWeight: 700,
}

const Wrapper = styled.div`
  display: none;

  @media (min-width: ${breakpoints.medium}px) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    font-weight: 500;
    margin-right: 40px;
  }

  > * + * {
    margin-left: 40px;
  }
`

const StyledTextItem = styled.div`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: currentColor;
  font-weight: 500;
  cursor: default;
`

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: currentColor;
  transition: opacity 0.25s ease-in-out;

  &:hover {
    opacity: 0.5;
  }

  &[aria-current="page"] {
    color: #95c01f !important;
    font-weight: 900;
  }  
`

const Chevron = styled.div`
  border-left: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  transform: rotate(-45deg);
  display: inline-block;
  width: 0.5em;
  height: 0.5em;
  margin-left: 0.8em;
`

const Drop = styled(motion.div)`
  display: none;
  position: absolute;
  left: -20px;
  padding-top: 15px;
`

const DropCard = styled.div`
  font-weight: 400;
  color: #111;
  background-color: #fff;
  box-shadow: 0 -4px 30px -10px rgba(28, 27, 126, 0.15);
  border: 1px solid #eaeaef;
  border-radius: 10px;
  padding: 15px 20px;
  min-width: 200px;
`

const DropWrapper = styled.div`
  position: relative;
`

const variants = {
  open: { opacity: 1, y: 0, display: "block" },
  closed: {
    opacity: 0,
    y: -5,
    transitionEnd: { display: "none" },
  },
}

const Dropmenu = ({ item }) => {
  const [show, setShow] = React.useState(false)

  const handleOnMouseOver = React.useCallback(() => {
    setShow(true)
  }, [])

  const handleOnMouseLeave = React.useCallback(() => {
    setShow(false)
  }, [])

  return (
    <DropWrapper
      onMouseLeave={handleOnMouseLeave}
      onMouseOver={handleOnMouseOver}
    >
      {item.to ? (
        <StyledLink to={item.to} activeStyle={activeStyle}>
          {item.label}
          <Chevron />
        </StyledLink>
      ) : (
        <StyledTextItem>
          {item.label}
          <Chevron />
        </StyledTextItem>
      )}
      <Drop
        animate={show ? "open" : "closed"}
        variants={variants}
        transition={{ duration: 0.4 }}
        initial={false}
      >
        <DropCard className="dropcard">
          <Spacer gap="small">
            {item.nested.map(subItem => (
              <StyledLink key={subItem.page.to} to={subItem.page.to}>
                {subItem.page.label}
              </StyledLink>
            ))}
          </Spacer>
        </DropCard>
      </Drop>
    </DropWrapper>
  )
}

const DesktopMenu = ({ menu }) => {
  return (
    <Wrapper>
      {menu.map((item, i) =>
        item.nested.length > 0 ? (
          <Dropmenu key={i} item={item} />
        ) : (
          <StyledLink key={i} to={item.to} activeStyle={activeStyle}>
            {item.label}
          </StyledLink>
        )
      )}
    </Wrapper>
  )
}

export default DesktopMenu
